import { RefreshCw } from 'lucide-react'
import { useVersionCheck } from '@/shared/hooks/use-version-check'
import { Button } from '@/shared/ui/button'

/**
 * Banner superior que avisa al usuario que está corriendo una versión
 * anterior de la plataforma. No recarga solo: deja que el usuario decida
 * para no interrumpir un formulario a medio llenar.
 */
export function UpdateBanner() {
  const updateAvailable = useVersionCheck()

  if (!updateAvailable) return null

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[100] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-primary px-4 py-2 text-sm text-primary-foreground shadow-md"
    >
      <RefreshCw className="h-4 w-4 shrink-0" />
      <span>Estás usando una versión anterior de la plataforma.</span>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => {
          window.location.reload()
        }}
      >
        Actualizar
      </Button>
    </div>
  )
}
